import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import ModeStrip from '.';
import DrawModeStrip from '../tool/Editor/ButtonDiv/Facet/DrawBtn/strip';
import AddPanelModeStrip from '../tool/Editor/ButtonDiv/Panel/AddPanelButton/strip';
import DeletePanelStrip from '../tool/Editor/ButtonDiv/Panel/DeletePanelBtn/strip';
import MovePanelStrip from '../tool/Editor/ButtonDiv/Panel/MovePanelButton/strip';
import ShowCurrentAzimuth from '../tool/Editor/ButtonDiv/Facet/ShowCurrentAzimuth';
import EditFacetModeStrip from '../tool/Editor/ButtonDiv/Facet/EditFacet/strip';
import EdgeToolStripContainer from '../tool/Editor/ButtonDiv/Facet/EdgeTool/toolStrip';
import DeleteFacetsStrip from 'components/tool/Editor/ButtonDiv/Facet/DeleteFacet/strip';
import EnableObstructionModeStrip from 'components/tool/Editor/ButtonDiv/Facet/EditObstructionBtn/strip';
import { selectCustomMap } from 'store/selectors/customMapSelector';
import ImageEditorStrip from 'components/ImageEditor/strip';
import TreeEditingModeStrip from 'components/Tree/strip';
import Show3DButton from 'components/ThreeDImage/Show3DButton';
import { Tree3DPill, TreeEditingModalBox, TreeEditingModalWrap } from './style';
import { DESIGN_MODES } from '../../constants';
import EditObstructionPointsOptionsStrip from 'components/tool/Editor/ButtonDiv/Facet/EditObstructionBtn/editObstructionPointsStrip';
import { LabelDiv, StripDiv, EditobstructionTabWrap } from './style';
import { useShowPolygonObsPointStrip } from 'components/tool/Editor/AddObstructionBtn/utils';
import { selectIsAnyToolActionActive } from 'store/selectors/toolSelector';
import { SpecialEdgesColorLegend } from 'components/tool/Facet/SpecialEdges/SpecialEdgeColorLegend';

export default function ModeStripContainer() {
	const { enableAddPanel, deleteIndividualPanelMode, enablePanelMove } = useSelector((state: RootState) => state.panelSlice.data);
	const { drawModeEnabled, selectedRoofIndex,
		selectedRoofAzimuth, deletedRoofIndexes, deleteFacetMode, enableEditObs,
		fullScreenEnabled, threeDModelEnabled
	} = useSelector((state: RootState) => state.toolNewPostions.data);
	const { mode } = useSelector((state: RootState) => state.roofData.data);
	const { enableEditFacet } = useSelector((state: RootState) => state.roofEditData.data);
	const { activeRoofTool } = useSelector((state: RootState) => state.roofToolLines.data);
	const { editModeEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { specialEdges, designType, showAutoDetectedEdges } = useSelector((state: RootState) => state.roofData.data);

	const isAnyActionEnabled = useSelector(selectIsAnyToolActionActive);
	const {selectedMap} = useSelector(selectCustomMap);
	const { treeEditingMode: treeEditingModeEnabled, isDrawingTree, isFlattenAreaMode, draftFlatten } = useSelector(
		(state: RootState) => state.treeSlice.data
	);
	const flattenDrawingInProgress = isFlattenAreaMode && draftFlatten.points.length > 0;
	const disableTree3DButton = flattenDrawingInProgress || isDrawingTree;
	const showTreeEditingStrip = editModeEnabled && treeEditingModeEnabled;
	const showTree3DButton = showTreeEditingStrip && mode !== DESIGN_MODES.NEARMAP_NREL_MANUAL;
	const showPolygonObsPointStrip = useShowPolygonObsPointStrip();

	return (
		<>
			{drawModeEnabled && <ModeStrip classname="drawStrip"><DrawModeStrip /></ModeStrip>}
			{/* {deleteObstructionsMode && <ModeStrip><DeleteObstructionModeStrip /></ModeStrip>}
			{addObstructionsMode && <ModeStrip><AddObstructionModeStrip /></ModeStrip>} */}
			{enableEditObs && (
				<ModeStrip>
					<EnableObstructionModeStrip />
				</ModeStrip>
			)}
			{showPolygonObsPointStrip && (
				<ModeStrip classname="obsPointsStrip">
					<StripDiv className='strip-edit_points'>
						<LabelDiv>Edit Points</LabelDiv>
						<EditobstructionTabWrap>
							<EditObstructionPointsOptionsStrip />
						</EditobstructionTabWrap>
					</StripDiv>
				</ModeStrip>
			)}
			{enableAddPanel && <ModeStrip><AddPanelModeStrip /></ModeStrip>}
			{deleteIndividualPanelMode && <ModeStrip><DeletePanelStrip /> </ModeStrip>}
			{enablePanelMove && <ModeStrip><MovePanelStrip /></ModeStrip>}
			{(selectedRoofIndex && selectedRoofAzimuth != null && !deletedRoofIndexes.includes(selectedRoofIndex)) && (
				<ModeStrip classname={'azimuthEdit'}><ShowCurrentAzimuth/></ModeStrip>
			)}
			{/* {enableEditFacet && <ModeStrip classname='editFacetWrap'> */}
			{enableEditFacet && <ModeStrip>

				<EditFacetModeStrip /> 
			</ModeStrip>}
			{/* Special Edges edit Mode */}
			{activeRoofTool && <EdgeToolStripContainer />}
			{deleteFacetMode && <ModeStrip><DeleteFacetsStrip/></ModeStrip>}

			{(designType === 'ROOF' && !!specialEdges.length && !isAnyActionEnabled &&
				(showAutoDetectedEdges || specialEdges.some(e => !e.isSystemDetected))) &&
				<SpecialEdgesColorLegend />}
			{/* custom maps */}
			{!!selectedMap && <ModeStrip classname='image-editor-strip'><ImageEditorStrip/></ModeStrip>}
			{showTreeEditingStrip && (
				<TreeEditingModalWrap $fullscreen={fullScreenEnabled}>
					<TreeEditingModalBox>
						<TreeEditingModeStrip />
					</TreeEditingModalBox>
					{showTree3DButton && (
						<Tree3DPill $active={threeDModelEnabled} $disabled={disableTree3DButton}>
							<Show3DButton className='in-pill' disabled={disableTree3DButton} />
						</Tree3DPill>
					)}
				</TreeEditingModalWrap>
			)}

		</>
	);
}
